export default "__VITE_ASSET__DJ4VCq2q__"